import { AlmanacFileShowItem } from 'hooks/queries/files/types'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { useScheduledPostTargets } from 'hooks/queries/scheduledPostTargets/useScheduledPostTargets'
import { ViewPostMenu, PostedAccount } from './ViewPostMenu'

interface PostedAccountsViewMenuProps {
  almanacFile: AlmanacFileShowItem
}

export const PostedAccountsViewMenu = ({ almanacFile }: PostedAccountsViewMenuProps) => {
  const scheduledPostId = almanacFile.scheduled_post?.id
  const { data: targets } = useScheduledPostTargets(scheduledPostId ?? 0, {
    enablePolling: true,
    enabled: !!scheduledPostId,
  })
  const { data: integrationsData } = useExternalIntegrations()

  const accounts: PostedAccount[] = (targets ?? [])
    .filter((t) => t.status === 'published' && !!t.post_url)
    .map((target) => {
      const integration = integrationsData?.external_integrations.find((i) => i.id === target.external_integration_id)
      return integration ? { target, integration } : null
    })
    .filter((a): a is PostedAccount => a !== null)

  if (accounts.length === 0) return null

  return <ViewPostMenu accounts={accounts} />
}
